import { logger } from "@/utils/debug";
import {
  AppAssistant,
  BuildAssistant,
  DiscoverAssistant,
  IntentAssistant,
  ReplyAssistant,
  WorkspaceAssistant,
} from "./assistants";
import { extractContextFromPathname } from "./utils/context";

export abstract class AI {
  /**
   * Sends a prompt to the AI assistant
   * Determines user intent and routes to the appropriate assistant
   * @param prompt - The prompt to send to the AI assistant
   * @returns The response from the AI assistant
   */
  static async prompt(prompt: string): Promise<void> {
    const pathname =
      typeof window !== "undefined" ? window.location.pathname : "/";
    const context = extractContextFromPathname(pathname);
    const intentAssistant = new IntentAssistant(context);
    const intentGuess = await intentAssistant.execute(prompt);

    logger.log("[AI.prompt] Intent guess result:", intentGuess);

    if (!intentGuess) {
      logger.warn(
        "[AI.prompt] No intent guess returned, cannot route to assistant"
      );
      return;
    }

    switch (intentGuess.intent) {
      case "workspace": {
        const dataflowId = context.params.dataflowId;
        logger.log(
          "[AI.prompt] Routing to WorkspaceAssistant with dataflowId:",
          dataflowId
        );
        const workspaceAssistant = new WorkspaceAssistant(dataflowId);
        await workspaceAssistant.execute(prompt);
        break;
      }

      case "app": {
        logger.log("[AI.prompt] Routing to AppAssistant");
        const appAssistant = new AppAssistant();
        await appAssistant.execute(prompt);
        break;
      }

      case "build": {
        logger.log("[AI.prompt] Routing to BuildAssistant");
        const buildAssistant = new BuildAssistant();
        await buildAssistant.execute(prompt);
        break;
      }

      case "discover": {
        logger.log("[AI.prompt] Routing to DiscoverAssistant");
        const discoverAssistant = new DiscoverAssistant();
        await discoverAssistant.execute(prompt);
        break;
      }

      case "reply": {
        logger.log("[AI.prompt] Routing to ReplyAssistant");
        const replyAssistant = new ReplyAssistant();
        await replyAssistant.execute(prompt);
        break;
      }

      default: {
        logger.warn("[AI.prompt] Unknown intent:", intentGuess.intent);
      }
    }
  }
}
